export default __webpack_public_path__ + "static/assets/927ed0f6ef393cd6d961e824614c2886.png";